export default "__VITE_ASSET__CJ4gvoKl__"